import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { authService } from '../services/api';
import { FaInbox, FaHome, FaBox, FaMusic, FaMicrophone, FaCalendar, FaUsers, FaUser, FaSignOutAlt, FaBars, FaTimes } from 'react-icons/fa';
import '../styles/Layout.css';

function Layout({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const user = authService.getCurrentUser();

  const menuItems = [
    { path: '/dashboard', icon: <FaHome />, label: 'Dashboard' },
    { path: '/anfragen', icon: <FaInbox />, label: 'Anfragen' },
    { path: '/feierpakete', icon: <FaBox />, label: 'Feierpakete' },
    { path: '/dj', icon: <FaMusic />, label: 'DJ buchen' },
    { path: '/livemusik', icon: <FaMicrophone />, label: 'Livemusik' },
    { path: '/kalender', icon: <FaCalendar />, label: 'Kalender' },
    { path: '/kunden', icon: <FaUsers />, label: 'Kunden' },
  ];

  if (user?.role === 'admin') {
    menuItems.push({ path: '/users', icon: <FaUser />, label: 'Benutzer' });
  }

  const handleLogout = () => {
    if (window.confirm('Möchtest du dich wirklich abmelden?')) {
      authService.logout();
      navigate('/login');
    }
  };

  return (
    <div className="layout">
      {/* Sidebar */}
      <aside className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <div className="logo">
            <img src="/logo.png" alt="HappyBeats" className="logo-image" />
          </div>
          <button className="sidebar-close" onClick={() => setSidebarOpen(false)}>
            <FaTimes />
          </button>
        </div>

        <nav className="sidebar-nav">
          {menuItems.map(item => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item ${location.pathname.startsWith(item.path) ? 'active' : ''}`}
              onClick={() => setSidebarOpen(false)}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
            </Link>
          ))}
        </nav>

        <div className="sidebar-footer">
          <div className="user-info">
            <div className="user-avatar">
              {user?.name?.charAt(0).toUpperCase() || 'U'}
            </div>
            <div className="user-details">
              <div className="user-name">{user?.name || 'User'}</div>
              <div className="user-role">{user?.role === 'admin' ? 'Administrator' : 'Benutzer'}</div>
            </div>
          </div>
          <button className="btn-logout" onClick={handleLogout}>
            <FaSignOutAlt />
            <span>Abmelden</span>
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <div className="main-content">
        <header className="top-header">
          <button className="menu-toggle" onClick={() => setSidebarOpen(true)}>
            <FaBars />
          </button>
          <div className="header-title">
            <h1>CRM System</h1>
          </div>
        </header>

        <main className="content">
          {children}
        </main>
      </div>

      {/* Overlay for mobile */}
      {sidebarOpen && (
        <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)}></div>
      )}
    </div>
  );
}

export default Layout;
